
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingut",
      function () {
        return require("private-next-pages/weingut/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingut"])
      });
    }
  